import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import * as moment from 'moment';
import { HamodelModel } from '../../../model/index';
import { HamodelService, CommonService, PocService } from '../../../services/index';

@Component({
    selector: 'walkintestingupd-tab',
    templateUrl: './walkintestingupdation.component.html',
})
export class ClientWalkinTestingDetComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;
    //@Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public stockList: any[] = [];
    partyCtrl: FormControl;
    typeCtrl: FormControl;
    numCtrl: FormControl;
    modelCtrl: FormControl;
    dateCtrl: FormControl;
    currTestingCtrl: FormControl;
    currTestingBranch: Observable<any[]>;
    updTestingCtrl: FormControl;
    updTestingBranch: Observable<any[]>;
    isLoadMask: Promise<any>;
    stockDet: HamodelModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    loadingIndicator: boolean = true;
    //reorderable: boolean = true;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;
    PartyList = [];
    ModelList = [];
    typeList = [];
    statusList = [];
    AcctypeList = [];
    paymentList = [];
    actModelList = [];
    pocData = [];
    // branchList: any[] = [];

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    showBranch = true;
    subscribeBranch;
    showUpdate: boolean;

    constructor(public store: Store<fromRootStore.State>, private hamodelService: HamodelService, public toasterService: ToasterService, private commonService: CommonService, private pocService: PocService) {
        //FOR AUTO COMPLETE VALIDATION --- PARTY COMBO

        this.stockDet = [];
        // this.stockDet['mode'] = 'Add';

        // this.branchCtrl = new FormControl();
        // this.filteredBranch = this.branchCtrl.valueChanges
        // .startWith(null)
        // .map(name => name ? this.filterBranch(name) : this.branchList.slice());
        this.currTestingCtrl = new FormControl();
        this.currTestingBranch = this.currTestingCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.currTestBranch(name) : this.pocData.slice());

        this.updTestingCtrl = new FormControl();
        this.updTestingBranch = this.updTestingCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.updateTestBranch(name) : this.pocData.slice());


        this.numCtrl = new FormControl('', [
            Validators.required
        ]);
        this.dateCtrl = new FormControl('', [
            Validators.required
        ]);


    }
    currTestBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.pocData.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayFn(testID: any) {
        if (this.pocData != undefined) {
            if (testID && this.pocData.length > 0) {
                let fitem = _.find(this.pocData, { 'id': testID });
                return fitem['name'];
            }
        }
        return '';
    }

    updateTestBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.pocData.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayUpdFn(testID: any) {
        if (this.pocData != undefined) {
            if (testID && this.pocData.length > 0) {
                let fitem = _.find(this.pocData, { 'id': testID });
                return fitem['name'];
            }
        }
        return '';
    }

    // filterBranch(name: string) {
    //     name = _.escapeRegExp(name);
    //     return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    // }
    // displayFn(branchID: any) {
    //     if (this.branchList != undefined) {
    //         if (branchID && this.branchList.length > 0) {
    //             let fitem = _.find(this.branchList, { 'branch_id': branchID });
    //             return fitem['branch_name'];
    //         }
    //     }
    //     return '';
    // }

    ngOnInit(): void {
        this.typeList = ['Testing Details', 'Status'];
        this.statusList = ['Testing', 'Trial', 'Therapy', 'Programing', 'Re-Programing', 'Re-Check up', 'Re-Trial', 'Fitting', 'Mould'];
        // this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
        //     if (_.isEmpty(res.data)) {
        //         return;
        //     }
        //     // this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        // });
        let params = {
            start: 0,
            limit: 500,
            orderColumn: 'name',
            orderDir: 'asc'
        };
        let that = this;
        this.pocService
            .getPocList(params)
            .then(function (res: any) {
                that.pocData = res.data;
            });
    }
    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onUpdateTestingDetails(): void {
        var toast = {
            type: 'error',
            title: 'ERROR'
        };

        if (this.stockDet['walkin_type'] == undefined || this.stockDet['data.walkin_type'] == '') {
            swal('WARNING', 'Please Select Change Type');
            return;
        }
        if (this.stockDet['client_no'] == undefined || this.stockDet['client_no'] == '') {
            swal('WARNING', 'Please Enter Client Number');
            return;
        }

        if (this.stockDet['walkin_date'] == undefined || this.stockDet['walkin_date'] == '') {
            swal('WARNING', 'Please Select Client Walk-in Date');
            return;
        }
        if ((this.stockDet['curr_test_det'] == undefined || this.stockDet['curr_test_det'] == '') && this.stockDet['walkin_type'] == 'Testing Details') {
            swal('WARNING', 'Please Select Client Current Testing Details');
            return;
        }
        if ((this.stockDet['upd_test_det'] == undefined || this.stockDet['upd_test_det'] == '') && this.stockDet['walkin_type'] == 'Testing Details') {
            swal('WARNING', 'Please Select Client Update Testing Details');
            return;
        }
        if ((this.stockDet['curr_status'] == undefined || this.stockDet['curr_status'] == '') && this.stockDet['walkin_type'] == 'Status') {
            swal('WARNING', 'Please Select Client Current Status');
            return;
        }
        if ((this.stockDet['update_status'] == undefined || this.stockDet['update_status'] == '') && this.stockDet['walkin_type'] == 'Status') {
            swal('WARNING', 'Please Select Client Update Status');
            return;
        }

        let current_testing_name = '';
        let update_testing_name = '';
        if (this.stockDet['curr_test_det']) {
            let curritem = _.find(this.pocData, { 'id': this.stockDet['curr_test_det'] });
            current_testing_name = curritem['name'];
        }
        if (this.stockDet['upd_test_det']) {
            let upditem = _.find(this.pocData, { 'id': this.stockDet['upd_test_det'] });
            update_testing_name = upditem['name'];
        }

        let that = this,
            data = {
                walkin_type: this.stockDet['walkin_type'],
                client_no: this.stockDet['client_no'],
                walkin_date: moment(this.stockDet['walkin_date']).format('YYYY-MM-DD'),
                curr_test_det: this.stockDet['curr_test_det'],
                upd_test_det: this.stockDet['upd_test_det'],
                curr_test_det_name: current_testing_name,
                upd_test_det_name: update_testing_name,
                curr_status: this.stockDet['curr_status'],
                update_status: this.stockDet['update_status'],
                // branch_id: this.stockDet['branch_id'],

            };

        // if (data.branch_id == undefined || data.branch_id == '') {
        //     swal('WARNING', 'Please Select Branch');
        //     return;
        // }

        if (this.stockDet['walkin_type']) {
            swal({
                title: 'Are you sure to update?',
                // text: 'You will not be able to Recover Client no: ' + data.client_no + ' details Again!',
                showCancelButton: true,
                confirmButtonText: 'Yes, Update!',
                cancelButtonText: 'No, Keep it'
            }).then(function () {
                that.isLoading = true;
                that.isLoadMask = that.commonService
                    .updateClientWalkinTestingEntry(data)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            that.stockDet = [];
                            swal('SUCCESS', res.message, 'success');
                        } else {
                            var toast = {
                                type: 'error',
                                title: 'ERROR',
                                body: res.message
                            };
                            that.toasterService.pop(toast);
                        }
                    });
            }, function (dismiss) {
            });
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/walkintestingupdation/walkintestingupdation.component.ts